import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as CarouselItemCreators } from 'store/carousel-items/carousel-items-duck.js';
import { Box, Button, IconButton, Typography } from '@mui/material';
import OrderableTable from 'components/orderable-table/index.jsx';
import EditSquareIcon from '@mui/icons-material/EditSquare';
import CarouselItemModal from './modal';
import DehazeIcon from '@mui/icons-material/Dehaze';
import AddIcon from '@mui/icons-material/Add';
import Carousel from 'components/carousel/index.jsx';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDeleteConfirmation } from 'hooks/useDeleteConfirmation.js';
import DeleteConfirmationModal from 'components/delete-confirmation-modal/index.jsx';
import PropTypes from 'prop-types';
import ThumbImage from 'components/thumb';

const CarouselItemsManagementPage = ({
  items,
  carouselItemsOpenModal,
  carouselItemsFetchAsync,
  carouselItemsUpdateOrder,
  carouselItemsUpdateOrdersAsync,
  carouselItemsDeleteAsync,
}) => {
  const {
    isOpen,
    message,
    open: openDeleteModal,
    close: closeDeleteModal,
    confirm: confirmDelete,
  } = useDeleteConfirmation();

  const fetchItems = useCallback(() => {
    carouselItemsFetchAsync();
  }, [carouselItemsFetchAsync]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleChangeOrder = (oldIndex, newIndex) => {
    carouselItemsUpdateOrder(oldIndex, newIndex);
  };

  const handleSaveOrder = () => {
    carouselItemsUpdateOrdersAsync();
  };

  const columns = [
    { title: '', key: 'draggable', render: () => <DehazeIcon /> },
    { title: 'Descrição', key: 'description' },
    { title: 'Link', key: 'link' },
    {
      key: 'imageLink',
      title: 'Imagem',
      width: 100,
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      render: (item) => <ThumbImage src={item.imageLink} alt={item.description} />,
    },
    {
      title: 'Ativo',
      key: 'active',
      render: (item) =>
        item.active ? (
          <Typography color="green">Ativo</Typography>
        ) : (
          <Typography color="red">Inativo</Typography>
        ),
    },
    {
      title: 'Ações',
      key: 'actions',
      render: (item) => (
        <>
          <IconButton onClick={() => carouselItemsOpenModal(item)}>
            <EditSquareIcon />
          </IconButton>
          <IconButton
            onClick={() =>
              openDeleteModal(
                () => carouselItemsDeleteAsync(item.id),
                'Tem certeza que deseja remover esse item do carrossel?',
              )
            }
            sx={{ color: 'red' }}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <>
      <CarouselItemModal />
      <DeleteConfirmationModal
        isOpen={isOpen}
        message={message}
        onConfirm={confirmDelete}
        onClose={closeDeleteModal}
      />

      <Typography variant="h5" gutterBottom>
        Edição de itens do Carrossel
      </Typography>
      <Button
        color="primary"
        variant="contained"
        onClick={() => carouselItemsOpenModal({ id: null, link: '', imageLink: '', active: true })}
        sx={{ mb: 2, borderRadius: '100%', width: '60px', height: '60px' }}
      >
        <AddIcon fontSize="large" />
      </Button>
      <OrderableTable
        columns={columns}
        data={items}
        rowKey="id"
        onChangeOrder={handleChangeOrder}
        onSaveOrderChange={handleSaveOrder}
      />

      <Box maxWidth={500}>
        <Typography variant="h5" justifyContent="center" gutterBottom>
          Preview
        </Typography>
        <Carousel items={items} />
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  items: state.CarouselItem.items,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(CarouselItemCreators, dispatch);
CarouselItemsManagementPage.propTypes = {
  items: PropTypes.array.isRequired,
  carouselItemsOpenModal: PropTypes.func.isRequired,
  carouselItemsFetchAsync: PropTypes.func.isRequired,
  carouselItemsUpdateOrder: PropTypes.func.isRequired,
  carouselItemsUpdateOrdersAsync: PropTypes.func.isRequired,
  carouselItemsDeleteAsync: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CarouselItemsManagementPage);
